<script setup lang="ts">
// Upload arrow over a baseline — the mark in a drag-or-browse dropzone
// (Figma 36076:127997). PrimeIcons' `pi-upload` draws a tray, not a baseline,
// and reads as a different family beside the design's stroke glyphs.
defineOptions({ inheritAttrs: false })
</script>

<template>
  <svg
    viewBox="0 0 23.8 21.1728"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path d="M11.9 16.2728V1.27279M18.9 8.27279L11.9 1.27279L4.9 8.27279M0.9 20.2728H22.9" />
  </svg>
</template>
